module.exports = __webpack_public_path__ + "img/novaholding.c6c5bdde.webp";